import { render } from "./CircularProgress.vue?vue&type=template&id=a7e95620&scoped=true"
import script from "./CircularProgress.vue?vue&type=script&lang=js"
export * from "./CircularProgress.vue?vue&type=script&lang=js"

import "./CircularProgress.vue?vue&type=style&index=0&id=a7e95620&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\New folder\\New folder\\Olt Care\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7e95620"]])

export default __exports__